import React from 'react';
import { Row } from '@squadcast/alchemy-ui/carbon';
import MetricCard from './MetricCard';

export interface MetricDataSet {
  triggered: {
    current: number;
    previous: number;
    percentChange: number;
  };
  acknowledged: {
    current: number;
    previous: number;
    percentChange: number;
  };
  resolved: {
    current: number;
    previous: number;
    percentChange: number;
  };
  suppressed: {
    current: number;
    previous: number;
    percentChange: number;
  };
  mtta: {
    current: number;
    previous: number;
    percentChange: number;
  };
  mttr: {
    current: number;
    previous: number;
    percentChange: number;
  };
}

interface MetricsDisplayProps {
  currentView: 'dash' | 'slo';
  currentDataSet: MetricDataSet;
  persistDataSet: any;
  calcDiff: (stateObj: any, key: string) => number;
}

const MetricsDisplay: React.FC<MetricsDisplayProps> = ({
  currentView,
  currentDataSet,
  persistDataSet,
  calcDiff,
}) => {
  // Tooltip contents for specific metrics
  const tooltipContents = {
    mtta: 'Average time taken to acknowledge incidents. It is calculated as a separate metric for every team that you are a part of in Squadcast.',
    mttr: 'Average time taken to resolve incidents. It is calculated as a separate metric for every team that you are a part of in Squadcast.',
  };

  if (currentView !== 'dash') return null;

  return (
    <div style={{ marginBottom: 40 }}>
      <Row alignContent="space-between" justifyContent="center">
        {Object.keys(currentDataSet).map((key, index) => {
          const persistDiff = calcDiff(persistDataSet, key);
          const isLastItem = index === Object.keys(currentDataSet).length - 1;

          return (
            <MetricCard
              key={key}
              metricKey={key}
              metricData={currentDataSet[key as keyof MetricDataSet]}
              persistDiff={persistDiff}
              tooltipContent={
                key === 'mtta' || key === 'mttr'
                  ? tooltipContents[key as 'mtta' | 'mttr']
                  : undefined
              }
            />
          );
        })}
      </Row>
    </div>
  );
};

export default MetricsDisplay;
